import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'AnaliseTec'

const GetAllByWork = (obraId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/obra?${obraId.map((n, index) => `obraID[${index}]=${n}`).join('&')}`, data, config)
const GetAllQuoteByContract = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/cotacao`, data, config)
const GetByAnalysis = (analiseTecId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${analiseTecId}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const ChangeLpu = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}/trocarLpu`, data, config)
const Update = (clone, data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}?cloneRevisaoAnterior=${clone}`, data, config)
const UpdateObs = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}/obs`, data, config)
const Cancel = (id, data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}/cancela/${id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${id}`, config)
const GetLog = (analiseTecItemId, config = {}) => APIClient.get(`${APIPci}/${resourceName}/log/${analiseTecItemId}`, config)
const ExportExcel = (lpuId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/exportexcel/${lpuId}`, data, config)
const ImportQuote = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/cotacao`, data, config)
const Desmembrar = (analiseTecID, obraIDs, config = {}) => APIClient.post(`${APIPci}/${resourceName}/desmembrar/${analiseTecID}`, obraIDs, config)

export default {
  GetAllByWork,
  GetAllQuoteByContract,
  GetByAnalysis,
  Create,
  ChangeLpu,
  Update,
  UpdateObs,
  Cancel,
  Delete,
  GetLog,
  ExportExcel,
  ImportQuote,
  Desmembrar
}



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/tecanalysis.js